import React from 'react';
import { Clock, Users, ShieldCheck } from 'lucide-react';
const ITEMS = [{
  icon: Clock,
  title: 'Fast availability',
  text: 'Priority scheduling for urgent plumbing needs.'
}, {
  icon: Users,
  title: 'Experienced team',
  text: 'Years of hands-on expertise on every job.'
}, {
  icon: ShieldCheck,
  title: 'Quality work',
  text: 'Satisfaction guaranteed, every visit.'
}];
export function Highlights() {
  return <section className="w-full bg-white" data-id="element-120" data-mp="302gg19kuq8wh">
      <div className="mx-auto grid max-w-6xl gap-5 px-4 py-4 sm:px-6 md:grid-cols-3" data-id="element-121" data-mp="340xdt2idu718">
        {ITEMS.map(({
        icon: Icon,
        title,
        text
      }) => <div key={title} className="rounded-2xl border border-slate-200 bg-white p-6 transition-shadow hover:shadow-sm" data-id="element-122" data-mp="38zh2vbs9vyxt">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-sky-50 text-sky-600" data-id="element-123" data-mp="obck4stj8453">
              <Icon className="h-5 w-5" data-id="element-124" data-mp="t8l32vmi8c7e" />
            </div>
            <h3 className="mt-4 font-heading text-lg font-semibold text-slate-900" data-id="element-125" data-mp="oc4m35cbk10g">{title}</h3>
            <p className="mt-1 text-sm text-slate-600" data-id="element-126" data-mp="kajg83y7cmzr">{text}</p>
          </div>)}
      </div>
    </section>;
}